import { forwardRef } from 'react';
import TextField, { TextFieldProps } from '../TextField';
import EmailFieldWithSuggestionList from './EmailFieldWithSuggestionList';

type EmailWithSuggestionProps = {
  onSuggestion: (value: string) => void;
  value?: string;
} & TextFieldProps;

const EmailFieldWithSuggestion = forwardRef<HTMLInputElement, EmailWithSuggestionProps>(
  ({ value, onSuggestion, ...otherProps }: EmailWithSuggestionProps, ref) => {
    return (
      <TextField
        {...otherProps}
        type="text"
        value={value}
        ref={ref}
        renderUnderlay={() => <EmailFieldWithSuggestionList input={value} onSelect={onSuggestion} />}
      />
    );
  },
);

export default EmailFieldWithSuggestion;
